import type {ReactElement} from 'react';
import {Button, Size, Type} from '@Components/button';
import {Text, TextSize} from '@Components/text';
import {getAssetUrl} from '@Utils/s3.util';
import styles from './ticketing-announcement-banner.module.scss';
import {TICKETING_HELP_CENTER_ARTICLE_URL} from '@Libraries/event-ticketing.library';

export function TicketingAnnouncementBanner(): ReactElement {
  return (
    <div className={`${styles.banner} flex-row-align-center gap-3 _full-width`}>
      <img className={styles.visual} src={getAssetUrl('ticketing-qr-visual.svg')} alt="" />
      <div className="flex-column-align-start flex-1 _overflow-hidden">
        <Text className="ct-neutral-primary-on-dark -truncated-text _full-width" val={window.i18next.t('pmwjs_tickets_are_here')} size={TextSize.MD} bold />
        <Text className="ct-neutral-secondary-on-dark -truncated-text _full-width" val={window.i18next.t('pmwjs_set_your_ticket_count_and_pricing_in_the_next_step')} size={TextSize.SM} />
      </div>
      <Button
        type={Type.SECONDARY}
        size={Size.XSMALL}
        text={window.i18next.t('pmwjs_learn_more')}
        href={TICKETING_HELP_CENTER_ARTICLE_URL}
        attributes={{target: '_blank', rel: 'noopener noreferrer'}}
      />
    </div>
  );
}
